import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";

import { Modal } from "@/components/General/Modal/modal";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    inactivityCountdown: number;
    modalState: boolean;
    toggleHandler: (newState: boolean) => void;
    logoutUser: () => void;
};

const InactivityMonitor = ({
    inactivityCountdown,
    modalState,
    toggleHandler,
    logoutUser
}: Props) => {
    const { t } = useGranite();
    return (
        <Modal
            title={t("ecorner.inactivityModal.title")}
            autoFocus={false}
            centered={true}
            size={"sm"}
            open={modalState}
            setOpen={toggleHandler}
            closable={true}
            withFooter={false}
        >
            {t("ecorner.inactivityModal.text", inactivityCountdown)}
            <div
                className={classnames(
                    "d-flex w-100 m-0 mt-2 mt-sm-3 align-items-center justify-content-between"
                )}
            >
                <Button
                    test="inactivityMonitor-button-cancel"
                    type="button"
                    onClick={() => toggleHandler?.(false)}
                >
                    {t("ecorner.inactivityModal.button.cancel")}
                </Button>
                <Button
                    test="inactivityMonitor-button-submit"
                    color={"gray"}
                    type="button"
                    onClick={() => logoutUser?.()}
                >
                    {t("ecorner.inactivityModal.button.logout")}
                </Button>
            </div>
        </Modal>
    );
};

export default InactivityMonitor;
